import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-2"
}

import { computed, watch } from "vue"
import FormRow from "@/components/Common/FormRow.vue"

type officeableType = {
  id: number | null
  name: string | null
  type: string | null
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectRow',
  props: {
    title: {},
    required: { type: Boolean },
    disabled: { type: Boolean, default: false },
    items: {},
    itemTitle: {},
    itemValue: {},
    modelValue: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const selectedItem = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const effectiveItems = computed(() => {
  return props.items.filter((item) => item.name !== null);
})

const hasSingleEffectiveItem = computed(() => {
  return effectiveItems.value.length === 1;
})

watch(effectiveItems, (newItems) => {
  if (newItems.length === 1) {
    selectedItem.value = newItems[0]
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(FormRow, {
    title: props.title,
    errors: props.errors,
    required: props.required
  }, {
    default: _withCtx(() => [
      (hasSingleEffectiveItem.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(selectedItem.value?.name), 1))
        : (_openBlock(), _createBlock(_component_v_select, _mergeProps({
            key: 1,
            "hide-details": "auto",
            class: "small pt-2",
            modelValue: selectedItem.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
            items: props.items,
            "item-title": props.itemTitle,
            "item-value": props.itemValue
          }, {'return-object': true}, {
            density: "compact",
            disabled: props.disabled,
            "error-messages": props.errors,
            clearable: false
          }), null, 16, ["modelValue", "items", "item-title", "item-value", "disabled", "error-messages"]))
    ]),
    _: 1
  }, 8, ["title", "errors", "required"]))
}
}

})